// We want to use comparison operators '< >' without type checking, so we need `any`
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { DefaultGlobalSort, DefaultSortBy } from '@unity/utils/constants';
import { CaseSensitivity, SortConfig } from '@unity/utils/types';

@Pipe({
  name: 'sort',
  standalone: true,
})
export class SortPipe implements PipeTransform {
  private isInsensitiveStringCompare(a: any, b: any, case_sensitive: CaseSensitivity = 'insensitive') {
    return (
      (a instanceof String || typeof a === 'string') && (b instanceof String || typeof b === 'string') && case_sensitive === 'insensitive'
    );
  }

  private isDirectNumericCompare(x: any, y: any) {
    return (x instanceof Number || typeof x === 'number') && (y instanceof Number || typeof y === 'number');
  }

  private sortBy<T extends Record<string, any>>(a: T, b: T, configs: SortConfig[]): number {
    let valA: any;
    let valB: any;
    const cfg = configs.pop();
    if (cfg == undefined) {
      return 0;
    }
    cfg.field ??= DefaultSortBy;

    if (this.isDirectNumericCompare(a, b) || this.isInsensitiveStringCompare(a, b, cfg.case_sensitive)) {
      valA = a;
      valB = b;
    } else {
      valA = a[cfg.field];
      valB = b[cfg.field];
    }

    if (this.isInsensitiveStringCompare(valA, valB, cfg.case_sensitive)) {
      valA = (valA as string).toLowerCase();
      valB = (valB as string).toLowerCase();
    }

    if (valA < valB) {
      return cfg.dir === 'desc' ? 1 : -1;
    }
    if (valA > valB) {
      return cfg.dir === 'desc' ? -1 : 1;
    }
    return this.sortBy(a, b, configs);
  }

  public transform<T extends any[] | null>(arr: T, configs: SortConfig[] = []): T {
    if (!arr || !configs) {
      return arr;
    }
    // First is assumed to be primary, so we flip to treat as a stack downstream
    configs.reverse();

    // Default config if none provided
    if (configs.length == 0) {
      configs.push(DefaultGlobalSort);
    }

    arr.sort((x, y) => this.sortBy(x, y, [...configs]));

    return arr;
  }
}
